<template>
  <b-row>
    <b-col cols="12">
      <b-card>
        <!-- <b-card-body> -->
        <h4
          v-if="title!==''"
          class="font-weight-bolder"
        >
          {{ title }}
        </h4>
        <data-table
          :data-table="dataClientItem"
          :field-table="dataClientField"
          :status="dataClientStatus"
          :table-for="table"
          :data-for="dataFor"
          :mutation-for="mutationFor"
          :filter-date="filterDate"
          :action="action"
          :filter-search="searchs"
          :button-download="buttonDownload"
        >
          <template
            #cell(actions)="data"
          >
            <b-button
              variant="outline-primary"
              size="sm"
              @click="viewDetail(data.item.client_id)"
            >
              <span class="align-middle">View</span>
            </b-button>
          </template>
        </data-table>
      <!-- </b-card-body> -->
      </b-card>

    </b-col>
  </b-row>
</template>
<script>
import {
  BRow, BCol, BCard, BButton,
} from 'bootstrap-vue'
import DataTable from '@/views/component/DataTable.vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    DataTable,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    statusAccount: Number,
    fromPage: {
      default: false,
      type: Boolean,
    },
    title: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      table: 'account',
      dataFor: 'dataClient',
      mutationFor: 'LIST',
      filterDate: false,
      action: false,
      searchs: true,
      buttonDownload: true,
    }
  },
  computed: {
    ...mapGetters('account', {
      dataClientField: 'getClientField',
      dataClientItem: 'getClientItem',
      dataClientStatus: 'getClientStatus',
      getListReason: 'getListReason',
    }),
  },
  mounted() {
    if (this.getListReason.length === 0) {
      this.listReason()
    }
    if (this.fromPage) {
      this.searchs = false
      this.buttonDownload = false
      // console.log(this.buttonDownload)
    }
    this.setStatus(this.statusAccount)
    this.clearTable()
    this.getDataList()
    this.dataReasonAccount()
  },
  methods: {
    ...mapMutations('account', {
      setDetail: 'SET_COMPANY_DETAIL',
      setStatus: 'SET_STATUS_APPROVE',
    }),
    ...mapActions('account', [
      'getDataList',
      'clearTable',
      'listReason',
    ]),
    ...mapActions('datas', [
      'dataReasonAccount',
    ]),
    viewDetail(id) {
      if (this.fromPage) {
        this.$router.push({ path: `/account/approval/view/${id}` })
      } else {
        const routeName = this.$route.matched[1].path
        // const routeName2 = this.$route.matched[1].path
        this.$router.push({ path: `${routeName}/view/${id}` })
      }
    },
    // getDetail(id) {
    //   const companies = this.dataClientItem
    //   const index = companies.findIndex(item => item.client_id === id)
    //   this.setDetail(companies[index])
    // },
  },
}
</script>
